
import { Helmet } from "react-helmet";
import Products from "../../components/products/products";

export default function ViewAllOnSale() {
    return (
        <>
            <Helmet>
                <title>SHOP.CO | On Sale - Best Deals & Discounts</title>
                <meta
                    name="description"
                    content="Discover all products currently on sale at SHOP.CO. Shop the best deals and enjoy discounts across categories."
                />

                <link
                    rel="canonical"
                    href="https://shop-co-roan.vercel.app/view-all-onSale/"
                />
            </Helmet>

            <Products endPoint="onSale-products" pageType="New Arrivals" initialFilters={{ isTrending: true }} />
        </>
    )
}